var _rect, _circle, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 17.5,
    width: 17.6777,
    height: 17.6777,
    rx: 5,
    transform: "rotate(-45 0 17.5)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "#08AAD5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2104_3773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5H9M9 12.5C9 14.433 10.567 16 12.5 16M9 12.5C9 10.567 10.567 9 12.5 9M16 12.5H17.5M16 12.5C16 14.433 14.433 16 12.5 16M16 12.5C16 10.567 14.433 9 12.5 9M12.5 7.5V9M12.5 16V17.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2104_3773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6.5 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueMarker);
export default __webpack_public_path__ + "static/media/blue-marker.9243be9c2de267108af2b68495e81cce.svg";
export { ForwardRef as ReactComponent };